export default __webpack_public_path__ + "static/media/Cuvette Fullstack Development Certificate - Niraj Srivastava_page-0001.59ab7477.jpg";